import {SvgIcon} from '@mui/material';

export const VerticalRule = (props: any) => {
  return (
    <SvgIcon {...props} viewBox="11 4 2 16">
      <path fillRule="evenodd" d="M11 4h2v16h-2z"></path>
    </SvgIcon>
  );
};
